import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.title.setTitle('Diego Pagini - Frontend Web Developer');

    this.meta.updateTag({
      name: 'description',
      content:
        'A web developer. Technology lover. Never stop learning | Angular',
    });

    // Twitter
    this.meta.addTag({
      name: 'twitter:card',
      content: 'summary',
    });

    this.meta.addTag({
      name: 'twitter:title',
      content: 'Diego Pagini - Frontend Web Developer',
    });

    this.meta.addTag({
      name: 'twitter:title',
      content:
        'A web developer. Technology lover. never stop learning | Angular',
    });
  }
}
